import { ThemeType } from '@gravity-ui/uikit';
import { checkThemeIsValid } from './getUserTheme';

export const THEME_STORAGE_NAME = 'vzhikTheme';

export const saveUserTheme = (theme: ThemeType) => {
    if (!checkThemeIsValid(theme)) {
        return;
    }

    localStorage.setItem(THEME_STORAGE_NAME, theme);
};
